import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {ArchiveDocumentsOpenerState} from "@/store/archiveDocumentsOpener/index";
import {RequestPayload, ServiceApi} from "@payroll/optimus-common";
import {ActionTree} from 'vuex'


export const actions: ActionTree<ArchiveDocumentsOpenerState, RootState> = {

  getMemberDetails: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('archiveDocumentsOpener/getMemberDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  getEmployerDetails: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback, pathVariable}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('archiveDocumentsOpener/getEmployerDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  createNewArchiveDocumentsOpener: ({commit, dispatch, state, rootGetters}: any, {formData, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('archiveDocumentsOpener')
      .setFormData(formData)
      .post(requestorCallback)
  },
}